<template>
    <div class="modal fade" id="votacion" aria-hidden="true" aria-labelledby="votacionLabel" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                    <div>
                        <h5 class="modal-title mb-3" id="votacionLabel">{{ $filters.CapitalizeFilter(nombreUsuario) }} estas emitiendo tu voto</h5>
                        <div v-for="cliente in operacion.clientes" :key="cliente.otro">
                            <p class="size14"> {{ $filters.CapitalizeFilter(cliente.nombre) }} </p>
                        </div>
                        <p class="size12"> No. Folio {{ operacion.folio }} </p>
                    </div>
                    <div class="container">
                        <div class="d-flex justify-content-around mt-2 mb-4">
                            <button type="button" v-on:click="mostrarA=true, mostrarR=false, mostrarTextArea=true" class="boton btn rounded-pill" :class="estaAprobada ? 'btn-info' : 'btn-primary'" @click="seleccionar('a')" >
                                <i class="bi bi-check-circle"></i> Aprobada
                            </button>
                            <button type="button" v-on:click="mostrarR=true, mostrarA=false, mostrarTextArea=true" class="boton btn rounded-pill" :class="estaRechazada ? 'btn-info' : 'btn-primary'" @click="seleccionar('r')">
                                <i class="bi bi-x-circle"></i> Rechazada
                            </button>
                            <button type="button" v-on:click="mostrarR=false, mostrarA=false, mostrarTextArea=true" class="boton btn rounded-pill" :class="estaPendiente ? 'btn-info' : 'btn-primary'" @click="seleccionar('p')">
                                <i class="bi bi-dash-circle"></i> Pendiente
                            </button>
                        </div>
                        <div>
                            <div v-if="mostrarA">
                             <p class="mt-3 size12">Calificación</p>
                             <select id="selectCalificacion" class="form-select mx-auto" aria-label="Default select">
                                 <option v-for="calificacion in calificacionesA" :key="calificacion">{{calificacion}} </option>
                             </select>
                            </div>
                            <div v-if="mostrarR">
                             <p class="mt-3 size12">Calificación</p>
                             <select  id="selectCalificacion" class="form-select mx-auto" aria-label="Default select">
                                 <option v-for="calificacion in calificacionesR" :key="calificacion">{{calificacion}} </option>
                            </select>
                            </div> 
                            <div v-if="mostrarTextArea" class="form-floating m-3">
                                <textarea class="form-control" maxlength="50" placeholder="Deja un comentario aqui" id="comentariosCalificacion" v-model="comentariosOperacion" style="height: 120px;"></textarea>
                                <label for="comentariosCalificacion">Comentarios</label>
                            </div>
                        </div>     
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button class="btn btn-primary rounded-pill boton" @click="guardarVoto()" :disabled="!votoListo" >Votar</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="modalVotoEmitido" aria-hidden="true" aria-labelledby="votacionLabel2" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
            
                <div class="modal-body text-center">
                    <h5 class="modal-title" id="votacionLabel">Votación</h5>
                    <div v-for="cliente in operacion.clientes" :key="cliente.otro">
                        <p> {{ $filters.CapitalizeFilter(cliente.nombre) }} </p>
                    </div>
                    <p class="size12"> No. Folio {{ operacion.folio }} </p>
                    <div class="contenedor">
                        <div v-if="votoi == 0">
                            <p>Has votado:</p>
                            <p><i class="bi bi-check-circle icono verde"></i></p>
                            <p>Aprobada</p>
                            <p>{{comentariosOperacion}}</p>
                        </div>
                        <div v-else-if="votoi == 1">
                            <p>Has votado:</p>
                            <p><i class="bi bi-x-circle icono rojo"></i></p>
                            <p>Rechazada</p>
                            <p>{{comentariosOperacion}}</p>
                        </div>
                        <div v-else-if="votoi == 2">
                            <p>Has votado:</p>
                            <p><i class="bi bi-dash-circle icono azul"></i></p>
                            <p>Pendiente</p>
                            <p>{{comentariosOperacion}}</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer d-flex justify-content-center">
                    <button class="btn btn-outline-primary rounded-pill me-4 boton" data-bs-target="#votacion" data-bs-toggle="modal">Cambiar voto</button>
                    <button class="btn btn-primary rounded-pill boton" data-bs-dismiss="modal">Aceptar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { defineComponent } from 'vue'
import * as bootstrap from 'bootstrap'

export default defineComponent({
    name: "ModalPanelVotacion",

    props: {
        operacion: {},
        mostrarRetorno: {
            type: Boolean,
            default: false
        },
        votoDto: {}
    },

    data() {
        return {
            usuario: {},
            votoListo: false,
            estaAprobada: false,
            estaRechazada: false,
            estaPendiente: false,
            mostrarA: false,
            mostrarR: false,
            mostrarTextArea: false,
            calificacionesA: [10,9,8],
            calificacionesR: [7,6],
            respuesta: "",
            calificacion: '',
            opcionElegida: '',
            votoi: '',
            comentariosOperacion: ''
        }
    },
    watch:{
        votoDto: function(newVal, oldVal) { 
            if(newVal != undefined)
            {
                if(newVal.voto != undefined)
                    {
                        this.votoi = newVal.voto;
                        this.comentariosOperacion = newVal.comentario;
                    }
            }
       }
    },
    computed: {
        nombreUsuario() {
            return this.obtenerPrimerNombre() + " " + this.usuario.apellidoPaterno
        }
    },

    mounted() {
        this.validarSesion();
    },

    methods: {
        seleccionar(valor) {
            if (valor == "a") {
                this.estaAprobada = true;
                this.estaRechazada = false;
                this.estaPendiente = false;
                this.opcionElegida = 0;
            }
            if (valor == "r") {
                this.estaAprobada = false;
                this.estaRechazada = true;
                this.estaPendiente = false;
                this.opcionElegida = 1;
            }
            if (valor == "p") {
                this.estaAprobada = false;
                this.estaRechazada = false;
                this.estaPendiente = true;
                this.opcionElegida = 2;
            }
            this.votoListo = this.estaAprobada || this.estaRechazada || this.estaPendiente
        },

         obtenerMensajeError(error) {
            if(String(error).includes("401")) {
                return 'Error de autenticación, por favor ingresa tus credenciales'
            }
            if(error == 'Error: Network Error') {
                return 'Error de conexión'
            }
            return error
        },

        async validarSesion() {
        await this.axios
            .post("Usuario/ValidarSesion")
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                    this.obtenerUsuarioSesion()
                }
            })
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: this.obtenerMensajeError(error)});
            })
        },

        async obtenerUsuarioSesion() {
        await this.axios
            .post("Usuario/ObtenerUsuarioSesion")
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                    this.usuario = this.respuesta.resultado
                }
                else {this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje})}
            })
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        },

        obtenerPrimerNombre() {
            var nombres
            if (String(this.usuario.nombre).includes(" ")) {
                nombres = this.usuario.nombre.split(" ")
                return nombres[0]
            }
            return this.usuario.nombre
        },

        async cerrarSesion() {
            await this.axios
            .post("Usuario/Logout")
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        },

        async guardarVoto() 
        {
            if(document.getElementById('selectCalificacion') != null)
                this.calificacion = document.getElementById('selectCalificacion').value;
            var params = {};
            params.OperacionId = this.$route.params.id;
            params.Voto = this.opcionElegida;
            params.Calificacion = this.estaPendiente ? null : this.calificacion;
            params.Comentario = this.comentariosOperacion;
            await this.axios
            .post("VotacionComiteCredito/Votar", params)
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                    if(this.respuesta.resultado != null)
                    {
                        //Cerramos el modal para votar
                        var modalVotacion = document.querySelector('#votacion');
                        bootstrap.Modal.getOrCreateInstance(modalVotacion).hide();
                        //Abrimos el modal con el voto ya guardado
                        var modalVotoEmitido = document.querySelector('#modalVotoEmitido');
                        bootstrap.Modal.getOrCreateInstance(modalVotoEmitido).show();
                        this.votoi = this.respuesta.resultado.voto;
                    }
                }
                this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje});
            })
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        }
    }
})
</script>

<style scoped>
    h5 {
        font-family: Montserrat; 
        font-weight: 700;
        font-style: normal;
        font-size: 17px;
        line-height: 20px;
        color: #4D4F5C;
    }

    p {
        font-family: Montserrat; 
        font-weight: 700;
        font-style: normal;
        line-height: 18px;
        color: #4D4F5C;
    }

    .size14 {
        font-size: 14px;
    }

    .size12 {
        font-size: 12px;
    }

    .contenedor {
        height: 200px;
    }

    .boton {
        font-family: Montserrat; 
        font-weight: 400;
        font-style: normal;
        font-size: 13px;
        line-height: 16px;
        width: 140px;
    }

    #selectCalificacion {
        width: 150px;
    }

    .icono {
        font-size: 60px;
    }

    .verde {
        color: #17AD61;
    }

    .rojo {
        color: #FF7285;
    }

    .azul {
        color: #568FFE;
    }
</style>